import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { fetchSearchAgentThreads } from '@/api/agents/searchAgent'

export function requireSearchAgent(enabled: boolean, params: { orgSlug: string; projectId: string }) {
  if (!enabled) {
    throw redirect({
      to: '/$orgSlug/$projectId/content/text',
      params: { orgSlug: params.orgSlug, projectId: params.projectId }
    })
  }
}

export const Route = createFileRoute('/_auth/$orgSlug/$projectId/search-agent')({
  beforeLoad: ({ context, params }) => {
    const enabled = context.user.userOrgProfile?.enabled_features.search_agent ?? false
    requireSearchAgent(enabled, params)
  },
  loader: async ({ params }) => {
    const projectId = parseInt(params.projectId, 10)
    const { threads } = await fetchSearchAgentThreads(projectId)
    return { threads }
  },
  component: SearchAgentLayout
})

function SearchAgentLayout() {
  return (
    <div className="flex h-full flex-col">
      <Outlet />
    </div>
  )
}
